export const REGISTER_ACTION = 'register';
export const REGISTER_CATEGORY = 'registration';
